export default __webpack_public_path__ + "static/media/img-industry-development-and-updates.600ac41e.png";